import dayjs from 'dayjs';

import { baseURL } from './functions';

import { IPost } from 'services/post/types';
import PATHS from 'utils/paths';

export const formatDataPost = (item: IPost) => ({
  title: item.title,
  description: item.shortDescription,
  srcImage: baseURL(item.thumbnail?.path),
  time: dayjs(item.publishedAt).format('DD/MM/YYYY'),
  href: PATHS.NEWS_DETAIL_WITH_SLUG(item.slug),
  view: Number(item.visited || 0),
});

export const remove = '';
